import { OfferColumnId } from '../../offers-page/offers-table/offers.table-service';
import { candidatesCountColumn } from './columns/candidates-count-column';
import { closedAtColumn } from './columns/closed-at-column';
import { createdAtColumn } from './columns/created-at-column';
import { departmentColumn } from './columns/department-column';
import { disqualifiedCountColumn } from './columns/disqualified-count-column';
import { eeoColumn } from './columns/eeo-column';
import { followersColumn } from './columns/followers-column';
import { hiredCountColumn } from './columns/hired-count-column';
import { hiringManagerColumn } from './columns/hiring-manager-column';
import { jobGuidColumn } from './columns/job-guid-column';
import { languagesColumn } from './columns/languages-column';
import { locationColumn } from './columns/location-column';
import { locationNameColumn } from './columns/location-name-column';
import { manageColumn } from './columns/manage-column';
import { newCandidatesCountColumn } from './columns/new-candidates-count-column';
import { priorityColumn } from './columns/priority-column';
import { publishedAtColumn } from './columns/published-at-column';
import { qualifiedCountColumn } from './columns/qualified-count-column';
import { recruiterColumn } from './columns/recruiter-column';
import { requisitionsColumn } from './columns/requisitions-column';
import { scheduledCloseColumn } from './columns/scheduled-close-column';
import { scheduledPublishColumn } from './columns/scheduled-publish-column';
import { stateColumn } from './columns/state-column';
import { tagsColumn } from './columns/tags-column';
import { titleColumn } from './columns/title-column';
import { workModelColumn } from './columns/work-model-column';

export type OfferTableFields =
  | 'candidates'
  | 'date_close'
  | 'date_created'
  | 'date_publish'
  | 'department'
  | 'disqualified_candidates'
  | 'followers'
  | 'hires'
  | 'hiring_manager'
  | 'job_id'
  | 'location'
  | 'location_name'
  | 'manage'
  | 'new_candidates'
  | 'qualified_candidates'
  | 'recruiter'
  | 'requisitions'
  | 'scheduled_close_date'
  | 'scheduled_publish_date'
  | 'state_region'
  | 'status'
  | 'tags'
  | 'languages'
  | 'title'
  | 'work_model'
  | 'priority'
  | 'eeo_compliance';

export const offerColumns = [
  titleColumn,
  tagsColumn,
  candidatesCountColumn,
  publishedAtColumn,
  createdAtColumn,
  closedAtColumn,
  followersColumn,
  recruiterColumn,
  hiringManagerColumn,
  newCandidatesCountColumn,
  languagesColumn,
  scheduledPublishColumn,
  scheduledCloseColumn,
  eeoColumn,
  jobGuidColumn,
  hiredCountColumn,
  departmentColumn,
  locationColumn,
  locationNameColumn,
  stateColumn,
  qualifiedCountColumn,
  disqualifiedCountColumn,
  requisitionsColumn,
  manageColumn,
  workModelColumn,
  priorityColumn,
];

export const offerColumnFieldMap: Partial<Record<OfferColumnId, OfferTableFields>> = {
  [OfferColumnId.CandidatesCount]: 'candidates',
  [OfferColumnId.ClosedAt]: 'date_close',
  [OfferColumnId.CreatedAt]: 'date_created',
  [OfferColumnId.PublishedAt]: 'date_publish',
  [OfferColumnId.Department]: 'department',
  [OfferColumnId.DisqualifiedCount]: 'disqualified_candidates',
  [OfferColumnId.Followers]: 'followers',
  [OfferColumnId.HiredCandidatesCount]: 'hires',
  [OfferColumnId.HiringManager]: 'hiring_manager',
  [OfferColumnId.JobGuid]: 'job_id',
  [OfferColumnId.LocationAddress]: 'location',
  [OfferColumnId.LocationName]: 'location_name',
  [OfferColumnId.Manage]: 'manage',
  [OfferColumnId.NewCandidatesCount]: 'new_candidates',
  [OfferColumnId.QualifiedCount]: 'qualified_candidates',
  [OfferColumnId.Recruiter]: 'recruiter',
  [OfferColumnId.Requisitions]: 'requisitions',
  [OfferColumnId.ScheduledClose]: 'scheduled_close_date',
  [OfferColumnId.ScheduledPublish]: 'scheduled_publish_date',
  [OfferColumnId.State]: 'state_region',
  [OfferColumnId.Tags]: 'tags',
  [OfferColumnId.Languages]: 'languages',
  [OfferColumnId.Eeo]: 'eeo_compliance',
  [OfferColumnId.Title]: 'title',
  [OfferColumnId.WorkModel]: 'work_model',
  [OfferColumnId.Priority]: 'priority',
};
